/**
 * Add to cart via Shopify API and redirect to checkout.
 * Only runs for forms inside .compact-buy-block__add-cart with data-type="add-to-cart-form".
 * Adds items via /cart/add.js, then redirects to /checkout.
 */
(function () {
  function getFormVariantId(form) {
    const input = form.querySelector('input[name="id"], .product-variant-id');
    if (!input || !input.value) return null;
    return parseInt(input.value, 10);
  }

  function getFormQuantity(form) {
    let input = form.querySelector('input[name="quantity"]');
    if (!input && form.id) {
      input = document.querySelector('input[name="quantity"][form="' + form.id + '"]');
    }
    if (!input) return 1;
    const qty = parseInt(input.value, 10);
    return isNaN(qty) || qty < 1 ? 1 : qty;
  }

  function setButtonLoading(button, loading) {
    if (!button) return;
    button.disabled = loading;
    const spinner = button.querySelector('.loading__spinner');
    const textSpan = button.querySelector('span:not(.loading__spinner *)');
    if (loading) {
      button.classList.add('loading');
      if (spinner) spinner.classList.remove('hidden');
      if (textSpan) textSpan.style.visibility = 'hidden';
    } else {
      button.classList.remove('loading');
      if (spinner) spinner.classList.add('hidden');
      if (textSpan) textSpan.style.visibility = '';
    }
  }

  function showFormError(form, message) {
    const wrapper = form.closest('product-form')?.querySelector('.product-form__error-message-wrapper');
    const messageEl = form.closest('product-form')?.querySelector('.product-form__error-message');
    if (wrapper && messageEl) {
      messageEl.textContent = message || 'Unable to add this product to the cart.';
      wrapper.hidden = false;
    } else {
      alert(message || 'Unable to add this product to the cart. Please try again.');
    }
  }

  function hideFormError(form) {
    const wrapper = form.closest('product-form')?.querySelector('.product-form__error-message-wrapper');
    if (wrapper) wrapper.hidden = true;
  }

  var SUBMITTING_KEY = 'addToCartCheckoutSubmitting';

  function handleAddToCartSubmit(e) {
    const form = e.target;
    if (form.getAttribute('data-type') !== 'add-to-cart-form') return;
    if (!form.closest('.compact-buy-block__add-cart')) return;

    if (form[SUBMITTING_KEY]) {
      e.preventDefault();
      e.stopImmediatePropagation();
      return;
    }
    form[SUBMITTING_KEY] = true;

    e.preventDefault();
    e.stopImmediatePropagation();
    hideFormError(form);

    const variantId = getFormVariantId(form);
    if (!variantId) {
      showFormError(form, 'Please select a variant.');
      return;
    }

    const quantity = getFormQuantity(form.closest('.compact-buy-block__add-cart'));
    const submitBtn = form.querySelector('[type="submit"][name="add"]');

    setButtonLoading(submitBtn, true);
    
    const root = window.Shopify?.routes?.root || '/';
    const url = `${root.replace(/\/$/, '')}/cart/add.js`;

    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: quantity }],
      }),
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) {
            return Promise.reject(data);
          }
          return data;
        });
      })
      .then(function () {
        window.location.href = '/checkout';
      })
      .catch(function (err) {
        form[SUBMITTING_KEY] = false;
        setButtonLoading(submitBtn, false);
        const message = (err && (err.description || err.message)) || 'Unable to add this product to the cart.';
        showFormError(form, message);
      });
  }

  var initDone = false;

  function init() {
    if (initDone) return;
    initDone = true;
    document.addEventListener('submit', handleAddToCartSubmit, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
